import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

export const ChatError = () => (
  <div className="flex size-full flex-col items-center justify-center">
    <Typography variant="label-sm">{t("chat_space.error_message")}</Typography>
  </div>
);
